import React from "react";

const LoadsBarCard = ({
  title = "Loads",
  legend = [
    { label: "Taken", slug: "taken", key: "taken" },
    { label: "Sold", slug: "sold", key: "sold" },
  ],
  data = [],
  valueFormat = "number",
}) => {
  const resolvedLegend = legend.map((item) => ({
    key: item.key || item.slug,
    ...item,
  }));

  const allValues = data.flatMap((item) =>
    resolvedLegend.map((serie) => {
      const val = item[serie.key];
      if (val === undefined || val === null) return 0;
      const numVal = Number(val);
      return isNaN(numVal) ? 0 : numVal;
    })
  );
  const maxValue = allValues.length > 0 ? Math.max(...allValues, 1) : 1;

  const formatValue = (value) => {
    if (valueFormat === "currency") {
      return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(value);
    }
    if (value >= 1000) return `${(value / 1000).toFixed(1)}k`;
    return value.toString();
  };

  return (
    <div className="chart-card loads-bar-card">
      <div className="chart-card__title-row">
        <span className="chart-card__title">{title}</span>
        <div className="chart-card__legend">
          {legend.map((item) => (
            <div className="chart-card__legend-item" key={item.slug}>
              <span className={`legend-dot legend-dot-${item.slug}`} />
              {item.label}
            </div>
          ))}
        </div>
      </div>

      <div className="loads-bar-card__chart">
        {data.map((item, idx) => (
          <div className="loads-bar-card__column" key={`bar-${idx}-${item.label || ""}`}>
            <div className="loads-bar-card__bar-group">
              {resolvedLegend.map((serie) => {
                const rawValue = item[serie.key];
                const value = rawValue !== undefined && rawValue !== null ? Number(rawValue) : 0;
                const height = value > 0 && maxValue > 0 ? Math.max(8, (value / maxValue) * 240) : 0;
                return (
                  <div key={serie.slug} className="loads-bar-card__bar-cell">
                    {value > 0 && (
                      <span className="loads-bar-card__bar-value">
                        {formatValue(value)}
                      </span>
                    )}
                    {height > 0 && (
                      <div
                        className={`bar bar-${serie.slug}`}
                        style={{ height: `${height}px` }}
                      />
                    )}
                  </div>
                );
              })}
            </div>
            <span className="loads-bar-card__label">{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LoadsBarCard;

